import React, { useState } from 'react';
import { FiPlus, FiCheckSquare } from 'react-icons/fi';
import ProjectSidebar from '../components/ProjectSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';

const initialTasks = [];
const COLUMNS = ['To Do', 'In Progress', 'Review', 'Done'];

export default function Tasks() {
  const [tasks, setTasks] = useLocalState('tasks_data', initialTasks);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleAdd = (newData) => {
    setTasks([{ ...newData, status: 'To Do', id: `TSK-${Date.now()}` }, ...tasks]);
  };

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <ProjectSidebar />
      <div className="flex-1 flex flex-col bg-gray-50 p-6">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center space-x-2">
            <FiCheckSquare className="text-xl text-[#0000a0]" />
            <h1 className="text-xl font-bold text-gray-800">Tasks Board</h1>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white px-4 py-2 rounded shadow flex items-center">
            <FiPlus className="mr-2" /> Add Task
          </button>
        </div>
        
        <div className="flex-1 overflow-x-auto">
          <div className="flex space-x-4 min-w-max h-full pb-4">
            {COLUMNS.map(col => (
              <div key={col} className="w-80 bg-gray-100 rounded-lg flex flex-col">
                <div className="p-3 border-b border-gray-200 bg-gray-200 rounded-t-lg font-bold text-gray-700">
                  {col}
                </div>
                <div className="flex-1 p-3 space-y-3 overflow-y-auto">
                  {tasks.filter(t => t.status === col).map(task => (
                    <div key={task.id} className="bg-white p-3 rounded shadow-sm border border-gray-200 cursor-pointer hover:shadow-md transition-shadow">
                      <div className="text-xs font-bold text-gray-500 mb-1">{task.id}</div>
                      <div className="font-bold text-sm text-gray-800 mb-2">{task.title}</div>
                      <div className="text-xs text-gray-500 mb-2">{task.project}</div>
                      <div className="flex justify-between items-center mt-2">
                        <span className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded">{task.assignee}</span>
                      </div>
                    </div>
                  ))}
                  {tasks.filter(t => t.status === col).length === 0 && (
                    <div className="text-center text-gray-400 text-sm italic py-4">No tasks</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Task" fields={[
          { name: 'title', label: 'Task Title' }, { name: 'project', label: 'Project Name' }, { name: 'assignee', label: 'Assignee' }
        ]} />
      </div>
    </div>
  );
}